<template>
    <div class="storeData_pane_trad">
        <div class="storeData_pane_trad_nap">
            <div
                class="trad_nap"
                :class="payListIndex == index ? 'trad_nap2' : 'trad_nap'"
                v-for="(items, index) in dataList"
                :key="index"
                @click="onclickTradNap(index)"
            >
                <p class="trad_nap_name">{{ items.name }}</p>
                <div class="trad_nap_num">
                    <p class="trad_nap_money">{{ items.count }}</p>
                </div>
            </div>
        </div>
        <div style="width: 1200px">
            <div
                class="my-charts"
                ref="myChart"
                id="myChart"
                :style="{ width: chartsWidth, height: '600px' }"
            ></div>
            <!-- :style="{ width: '1200px', height: '600px' }" -->

        </div>
    </div>
</template>
<script>
export default {
    // 交易数据
    name: "realTimeDesign",
    props: {
        chartsWidth: String,
    },
    data() {
        return {
            payListIndex: "0",
            dataList: [],
            timeList: [],
            visitorCountList: [],
            lastVisitorCountList: [],
            viewCountList: [],
            lastViewCountList: [],
            orderCountList: [],
            lastOrderCountList: [],
            payCountList: [],
            lastPayCountList: [],

        };
    },
    /*  mounted() {
            this.drawLine();
      },*/
    methods: {
        init(resData) {
            this.dataList = [];
            if (resData.timeType != "nowDay") {
                let visitorParam = {
                    id: "0",
                    name: "访客数",
                    count: resData.visitorCount,
                }
                let viewParam = {
                    id: "1",
                    name: "浏览量",
                    count: resData.viewCount,
                }
                let orderParam = {
                    id: "2",
                    name: "订单数",
                    count: resData.orderCount,
                }
                let payParam = {
                    id: "3",
                    name: "支付金额",
                    count: resData.payCount,
                }
                this.dataList.push(visitorParam);
                this.dataList.push(viewParam);
                this.dataList.push(orderParam);
                this.dataList.push(payParam);
            }
            this.timeList = resData.timeList;
            this.visitorCountList = resData.visitorCountList,
                this.lastVisitorCountList = resData.lastVisitorCountList,
                this.viewCountList = resData.viewCountList,
                this.lastViewCountList = resData.lastViewCountList,
                this.orderCountList = resData.orderCountList,
                this.lastOrderCountList = resData.lastOrderCountList,
                this.payCountList = resData.payCountList,
                this.lastPayCountList = resData.lastPayCountList,

                this.drawLine(this.timeList, this.visitorCountList, this.lastVisitorCountList);
        },
        onclickTradNap(index) {
            this.payListIndex = index;
            if (index == 0) {
                this.drawLine(this.timeList, this.visitorCountList, this.lastVisitorCountList);
            } else if (index == 1) {
                this.drawLine(this.timeList, this.viewCountList, this.lastViewCountList);
            } else if (index == 2) {
                this.drawLine(this.timeList, this.orderCountList, this.lastOrderCountList);
            } else if (index == 3) {
                this.drawLine(this.timeList, this.payCountList, this.lastPayCountList);
            }
        },
        drawLine(xData, y1Data, y2Data) {
            // 基于准备好的dom，初始化echarts实例
            //检测是否已经存在echarts实例，如果不存在，则不再去初始化
            let myChart = this.$echarts.getInstanceByDom(
                this.$refs.myChart
            );
            if (myChart == null) {
                myChart = this.$echarts.init(this.$refs.myChart);
            }
            // 绘制图表
            myChart.setOption({
                // title: {
                //   text: "当周批转量和报备量",
                //   left: "5%",
                // },
                tooltip: {trigger: "axis"},
                legend: {
                    data: ["今日", "昨日"],
                    right: "5%",
                },
                grid: {
                    left: "5%",
                    right: "6%",
                    bottom: "10%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: xData,
                    axisLine: {
                        lineStyle: {
                            color: "#999",
                            width: 0.1
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: "#999",
                            width: 0.1,
                        },
                    },
                },
                yAxis: {
                    type: "value",
                    axisLine: {
                        lineStyle: {
                            color: "#999",
                            width: 0.1
                        },
                    },
                },
                series: [
                    {
                        name: "今日",
                        type: "line",
                        data: y1Data,
                        // areaStyle: {
                        //   color: "rgb(237,252,245)",
                        // },
                        smooth: true,
                        itemStyle: {
                            normal: {
                                color: "#53e59d",
                            },
                        },
                    },
                    {
                        name: "昨日",
                        type: "line",
                        data: y2Data,
                        // areaStyle: {
                        //   color: "rgb(220,247,245)",
                        // },
                        smooth: true,
                        itemStyle: {
                            normal: {
                                color: "#43c4fd",
                            },
                        },
                    },
                ],
            });
        },
    },
};
</script>
<style scoped lang="less">
.storeData_pane_trad {
    .storeData_pane_trad_nap {
        display: flex;
        align-items: center;

        .trad_nap2 {
            background: rgba(147, 185, 255, 0.158);
            border-bottom: 4px solid rgb(88, 146, 253);
        }

        .trad_nap {
            padding: 20px 40px;
            font-size: 14px;
            width: 30%;
            cursor: pointer;

            &:hover {
                background: rgba(185, 210, 255, 0.158);
            }

            .trad_nap_name {
                margin-bottom: 15px;
            }

            .trad_nap_num {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .trad_nap_money {
                    font-weight: bold;
                }

                .trad_nap_mess {
                    color: #666;
                }

                .trad_nap_pre {
                    display: flex;
                    align-items: center;
                    color: red;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/statistic/realTimeDesign.vue